module.exports = __webpack_public_path__ + "assets/img/service-advertising-hero.b9eedf39.jpg";